var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},_vm._l((_vm.data),function(x){return _c('div',{key:x.value,staticClass:"col-md-12",on:{"change":function($event){return _vm.onChange($event,x.value)}}},[_c('b-form-checkbox',{attrs:{"checked":_vm.item.indexOf(x.value) >= 0}},[_vm._v(_vm._s(x.text))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }